<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <form class="ui form" [formGroup]="profileForm">
      <div
        class="field"
        [ngClass]="displayFieldCss('profileName')"
        appMargin
        marginB="15px"
      >
        <label class="required">Profile Name</label>
        <input type="text" formControlName="profileName" />

        <app-field-error-display
          [displayError]="isFieldValid('profileName')"
          errorMsg="Please provide detail"
        >
        </app-field-error-display>
      </div>
      <div
        class="field"
        [ngClass]="displayFieldCss('countries')"
        appMargin
        marginB="15px"
      >
        <label class="required"
          >Blacklisted Countries
          <small style="font-size: 12px"
            >(Multiple Countries can be added)</small
          ></label
        >
        <div class="ui fluid multiple selection dropdown" suiDropdown>
          <input
            type="hidden"
            name="countries"
            [value]="selectedCountries"
            formControlName="countries"
          />
          <i class="dropdown icon"></i>
          <div class="default text" *ngIf="selectedCountries.length === 0">
            Select Countries
          </div>
          <div class="text" *ngIf="selectedCountries.length > 0">
            {{ getSelectedCountriesText() }}
          </div>
          <div class="menu" suiDropdownMenu>
            <div
              *ngFor="let country of countries"
              class="item"
              [class.selected]="isCountrySelected(country)"
              (click)="toggleCountrySelection(country)"
            >
              <i class="check box icon" *ngIf="isCountrySelected(country)"></i>
              <span>{{ country.countryName }}</span>
            </div>
          </div>
        </div>

        <app-field-error-display
          [displayError]="isFieldValid('countries')"
          errorMsg="Please select one or more countries"
        >
        </app-field-error-display>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: transparent; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    (click)="this.extraData.isAdd ? add() : update()"
    [disabled]="pending || !profileForm.valid"
    class="ui primary button"
  >
    Save
  </button>
</div>
